import type { FunctionComponent, ReactElement } from 'react';
import { useEffect } from 'react';

import { useTranslation } from '../../../api/useTranslation';
import { ButtonVariant } from '../../controls/button/Button';
import { Curtain } from '../../curtain/Curtain';

import { BlockingModalActionButton, BlockingModalContent } from './BlockingModalContent';

interface GenericErrorConnectedProps {
  inCurtain?: boolean;
}

export const GenericErrorConnected: FunctionComponent<GenericErrorConnectedProps> = ({ inCurtain }): ReactElement => {
  const { translations, isFetching } = useTranslation();

  const translationKey =
    isFetching || !translations ? 'Please contact Customer Support for assistance' : 'GENERIC_ERROR';

  const action: BlockingModalActionButton[] = [
    {
      tk: 'OK',
      type: ButtonVariant.ACCENT,
      click: (): void => {
        location.reload();
      },
    },
  ];

  useEffect(() => {
    if (inCurtain) return;
    // Error may occur on initial loading. Remove curtain so that error popup is displayed
    Curtain.remove();
  }, [inCurtain]);

  return <BlockingModalContent messageTk={translationKey} actions={action} inCurtain={inCurtain} />;
};
